<template>
  <div>
    <app-cells><h2 class="title">Reservation status</h2></app-cells>
    <v-client-table
      :data="table_reservation_status.items"
      :columns="table_reservation_status.columns"
      :options="table_reservation_status.options"
      class="table-default"
    >
      <template #h__manager><div class="table-default__left">Manager</div></template>
      <template #h__from><div class="table-default__left">From</div></template>
      <template #h__to><div class="table-default__left">To</div></template>
      <template #date="{ row }">{{ dateTimeFormat(row.timestamp) }}</template>
      <template #from="{ row }">
        <div class="table-default__left">
          <span class="status-tag" :style="{ 'backgroundColor': row.current.color }">{{ row.current.name }}</span>
        </div>
      </template>
      <template #to="{ row }">
        <div class="table-default__left">
          <span class="status-tag" :style="{ 'backgroundColor': row.new.color }">{{ row.new.name }}</span>
        </div>
      </template>
      <template #manager="{ row }">
        <div class="table-default__left table-default__left--photo">
          <template v-if="row.manager">
            <div class="table-default__photo">
              <img :src="getUserAvatar(row.manager.crop.crop_url)" alt="Avatar">
            </div>
            <span>{{ row.manager.full_name }}</span>
          </template>
          <span v-else>System</span>
        </div>
      </template>
    </v-client-table>
    <app-cells position="between">
      <div>
        <paginate
          :clickHandler="onClickReservationPagination"
          v-if="pagination_reservation_status.pages > 1"
          v-model="pagination_reservation_status.page"
          :page-count="pagination_reservation_status.pages"
          :prev-text="'<'"
          :next-text="'>'"
          :container-class="'pagination'"
          :page-class="'pagination__item'"
          :page-link-class="'pagination__link'"
          :prev-class="'pagination__item pagination__item--prev'"
          :next-class="'pagination__item pagination__item--next'"
          :next-link-class="'pagination__link pagination__link--next'"
          :prev-link-class="'pagination__link pagination__link--prev'"
        />
      </div>
      <app-table-records :all="pagination_reservation_status.count" :count="table_reservation_status.items.length" :page="pagination_reservation_status.page" />
    </app-cells>

    <app-cells><h2 class="title">Sales status</h2></app-cells>
    <v-client-table
      :data="table_sales_status.items"
      :columns="table_sales_status.columns"
      :options="table_sales_status.options"
      class="table-default"
    >
      <template #h__manager><div class="table-default__left">Manager</div></template>
      <template #h__from><div class="table-default__left">From</div></template>
      <template #h__to><div class="table-default__left">To</div></template>
      <template #date="{ row }">{{ dateTimeFormat(row.timestamp) }}</template>
      <template #from="{ row }">
        <div class="table-default__left">
          <span class="status-tag" :style="{ 'backgroundColor': row.current.color }">{{ row.current.name }}</span>
        </div>
      </template>
      <template #to="{ row }">
        <div class="table-default__left">
          <span class="status-tag" :style="{ 'backgroundColor': row.new.color }">{{ row.new.name }}</span>
        </div>
      </template>
      <template #manager="{ row }">
        <div class="table-default__left table-default__left--photo">
          <template v-if="row.manager">
            <div class="table-default__photo">
              <img :src="getUserAvatar(row.manager.crop.crop_url)" alt="Avatar">
            </div>
            <span>{{ row.manager.full_name }}</span>
          </template>
          <span v-else>System</span>
        </div>
      </template>
    </v-client-table>
    <app-cells position="between">
      <div>
        <paginate
          :clickHandler="onClickSalesPagination"
          v-if="pagination_sales_status.pages > 1"
          v-model="pagination_sales_status.page"
          :page-count="pagination_sales_status.pages"
          :prev-text="'<'"
          :next-text="'>'"
          :container-class="'pagination'"
          :page-class="'pagination__item'"
          :page-link-class="'pagination__link'"
          :prev-class="'pagination__item pagination__item--prev'"
          :next-class="'pagination__item pagination__item--next'"
          :next-link-class="'pagination__link pagination__link--next'"
          :prev-link-class="'pagination__link pagination__link--prev'"
        />
      </div>
      <app-table-records :all="pagination_sales_status.count" :count="table_sales_status.items.length" :page="pagination_sales_status.page" />
    </app-cells>

    <template v-if="table_cancellations.items.length > 0">
      <app-cells><h2 class="title">Cancellations</h2></app-cells>
      <v-client-table
        :data="table_cancellations.items"
        :columns="table_cancellations.columns"
        :options="table_cancellations.options"
        class="table-default"
      >
        <template #count="{ row, index }">{{ index }}</template>
        <template #created_by="{ row }">
          <div class="table-default__controls">
            <div class="table-default__photo">
              <img
                :src="getUserAvatar(row.created_by?.crop?.crop_url)" alt="Avatar"
                v-tooltip="{ content: row.created_by.full_name, placement: 'top-start', offset: 10, html: true }"
              >
            </div>
            {{ dateTimeFormat(row.created_at) }}
          </div>
        </template>
        <template #updated_by="{ row }">
          <div class="table-default__controls">
            <div class="table-default__photo">
              <img
                :src="getUserAvatar(row.updated_by?.crop?.crop_url)" alt="Avatar"
                v-tooltip="{ content: row.updated_by.full_name, placement: 'top-start', offset: 10, html: true }"
              >
            </div>
            {{ dateTimeFormat(row.updated_at) }}
          </div>
        </template>
        <template #sales_status="{ row }">
          <div class="status-tag" :style="{ 'backgroundColor': row.sales_status.color }">
            {{ row.sales_status.name }}
          </div>
        </template>
        <template #reservation_status="{ row }">
          <div class="status-tag" :style="{ 'backgroundColor': row.reservation_status.color }">
            {{ row.reservation_status.name }}
          </div>
        </template>
        <template #amount="{ row }">{{ row.amount ? `${row.amount} $` : '-' }}</template>
      </v-client-table>
    </template>
    <template v-if="table_amendments.items.length > 0">
      <app-cells><h2 class="title">Amendments</h2></app-cells>
      <v-client-table
        :data="table_amendments.items"
        :columns="table_amendments.columns"
        :options="table_amendments.options"
        class="table-default"
      >
        <template #count="{ row, index }">{{ index }}</template>
        <template #created_by="{ row }">
          <div class="table-default__controls">
            <div class="table-default__photo">
              <img
                :src="getUserAvatar(row.created_by?.crop?.crop_url)" alt="Avatar"
                v-tooltip="{ content: row.created_by.full_name, placement: 'top-start', offset: 10, html: true }"
              >
            </div>
            {{ dateTimeFormat(row.created_at) }}
          </div>
        </template>
        <template #updated_by="{ row }">
          <div class="table-default__controls">
            <div class="table-default__photo">
              <img
                :src="getUserAvatar(row.updated_by?.crop?.crop_url)" alt="Avatar"
                v-tooltip="{ content: row.updated_by.full_name, placement: 'top-start', offset: 10, html: true }"
              >
            </div>
            {{ dateTimeFormat(row.updated_at) }}
          </div>
        </template>
        <template #sales_status="{ row }">
          <div class="status-tag" :style="{ 'backgroundColor': row.sales_status.color }">
            {{ row.sales_status.name }}
          </div>
        </template>
        <template #reservation_status="{ row }">
          <div class="status-tag" :style="{ 'backgroundColor': row.reservation_status.color }">
            {{ row.reservation_status.name }}
          </div>
        </template>
        <template #amount="{ row }">{{ row.amount ? `${row.amount} $` : '-' }}</template>
      </v-client-table>
    </template>
  </div>
</template>

<script>
import {
  getReservationsHotelAmendmentRequests,
  getReservationsHotelReservationStatusLogs, getReservationsHotelSalesStatusLogs,
  getReservationsHotelsCancellationRequests
} from '@/http'
import { format, parseISO } from 'date-fns'

export default {
  name: 'HotelsReservationsHistory',
  data() {
    return {
      table_cancellations: {
        items: [],
        columns: ['count', 'created_by', 'updated_by', 'sales_status', 'reservation_status', 'amount'],
        options: {
          headings: {
            count: '#',
            created_by: 'Created by',
            updated_by: 'Updated by',
            sales_status: 'Sales status',
            reservation_status: 'Reservation status',
            amount: 'Amount',
          },
          pagination: { show: false },
          sortable: [],
          perPage: 100,
          texts: {
            noResults: 'No matching entries',
          },
          rowClassCallback: () => 'table-default__row',
          resizableColumns: false
        }
      },
      table_amendments: {
        items: [],
        columns: ['count', 'created_by', 'updated_by', 'sales_status', 'reservation_status', 'amount'],
        options: {
          headings: {
            count: '#',
            created_by: 'Created by',
            updated_by: 'Updated by',
            sales_status: 'Sales status',
            reservation_status: 'Reservation status',
            amount: 'Amount',
          },
          pagination: { show: false },
          sortable: [],
          perPage: 100,
          texts: {
            noResults: 'No matching entries',
          },
          rowClassCallback: () => 'table-default__row',
          resizableColumns: false
        }
      },
      table_reservation_status: {
        items: [],
        columns: [
          'date',
          'from',
          'to',
          'manager',
        ],
        options: {
          headings: {
            date: 'Date',
            from: 'From',
            to: 'To',
            manager: 'Manager',
          },
          pagination: {show: false},
          sortable: [],
          perPage: 20,
          texts: {
            noResults: 'No matching entries',
          },
          rowClassCallback: () => 'table-default__row',
          resizableColumns: false
        },
      },
      table_sales_status: {
        items: [],
        columns: [
          'date',
          'from',
          'to',
          'manager',
        ],
        options: {
          headings: {
            date: 'Date',
            from: 'From',
            to: 'To',
            manager: 'Manager',
          },
          pagination: {show: false},
          sortable: [],
          perPage: 20,
          texts: {
            noResults: 'No matching entries',
          },
          rowClassCallback: () => 'table-default__row',
          resizableColumns: false
        },
      },
      pagination_reservation_status: {
        pages: 1,
        page: 1,
        count: 1,
      },
      pagination_sales_status: {
        pages: 1,
        page: 1,
        count: 1,
      },
    }
  },
  created() {
    Promise.all([
      getReservationsHotelsCancellationRequests({ reservation__id: this.$route.params.id }),
      getReservationsHotelAmendmentRequests({ reservation__id: this.$route.params.id }),
    ])
      .then(res => {
        this.table_cancellations.items = res[0].data
        this.table_amendments.items = res[1].data
      })
    this.fetchReservationItems()
    this.fetchSalesItems()
  },
  methods: {
    fetchReservationItems() {
      getReservationsHotelReservationStatusLogs(this.$route.params.id, { page: this.pagination_reservation_status.page, page_size: 20 })
        .then(response => {
          this.table_reservation_status.items = response.data.results
          this.pagination_reservation_status.pages = response.data.pages
          this.pagination_reservation_status.count = response.data.count
        })
    },
    fetchSalesItems() {
      getReservationsHotelSalesStatusLogs(this.$route.params.id, { page: this.pagination_sales_status.page, page_size: 20 })
        .then(response => {
          this.table_sales_status.items = response.data.results
          this.pagination_sales_status.pages = response.data.pages
          this.pagination_sales_status.count = response.data.count
        })
    },
    onClickReservationPagination(page) {
      this.pagination_reservation_status.page = page
      this.fetchReservationItems()
    },
    onClickSalesPagination(page) {
      this.pagination_sales_status.page = page
      this.fetchSalesItems()
    },
    dateTimeFormat(date) {
      return date ? format(parseISO(date), 'dd MMM yyyy HH:mm') : '-'
    },
    getUserAvatar(crop_url) {
      if (crop_url) return crop_url
      return require('@/assets/img/temp/avatar-slug.jpg')
    },
  }
}
</script>
